export default "__VITE_ASSET__wm1zIVPQ__"